import { useSignalROn } from "@/helpers/signalr.ts";
import { type HeldReplyStatus, SigRInvoke, SigROn } from "@/types/signalr-functions.ts";
import { JsonParse } from "@/helpers/json.ts";
import { useChatStore } from "@/stores/useChatStore.ts";
import { deriveHeldReplyState, IsHeldReplyStateSomething } from "@/api/chat.ts";
import { useSignalStore } from "@/stores/useSignalrStore.ts";
import { useCallback, useEffect } from "react";
import { useActiveSessionStore } from "@/stores/useActiveSessionStore.ts";

export const useHookAiTutor = () => {
  const { signalr } = useSignalStore();

  useEffect(() => {
    if (!signalr) return;

    const callback = () => {
      const { activeSessions, helpRequestedSessions } = useActiveSessionStore.getState();

      activeSessions.forEach((sessions) => {
        sessions.forEach((session) => {
          if (session.flowGeneratorSessionId)
            signalr
              .Invoke(
                SigRInvoke.JoinAiTutorResponseGroup,
                session.flowGeneratorSessionId.toString(),
              )
              .catch((e) => console.warn(e));
        });

        helpRequestedSessions.forEach((session) => {
          if (session.flowGeneratorSessionId)
            signalr
              .Invoke(
                SigRInvoke.JoinAiTutorResponseGroup,
                session.flowGeneratorSessionId.toString(),
              )
              .catch((e) => console.warn(e));
        });
      });
    };

    signalr.withOnStartup(callback);

    return () => {
      if (signalr) signalr.removeCallback(callback);
    };
  }, [signalr]);

  const aiTutorCallback = useCallback((data: string) => {
    let flaggedMessage = JsonParse<HeldReplyStatus>(data);
    if (flaggedMessage === null || flaggedMessage.flowGeneratorSessionId === undefined) return;

    const { SetFlaggedMessage } = useChatStore.getState();

    const parsedFlagged = deriveHeldReplyState(flaggedMessage);

    if (IsHeldReplyStateSomething(parsedFlagged)) {
      const { AddNewChat, chats } = useChatStore.getState();

      if (!chats.get(flaggedMessage.flowGeneratorSessionId))
        AddNewChat({
          flowGeneratorSessionId: flaggedMessage.flowGeneratorSessionId,
        });
    }

    SetFlaggedMessage(flaggedMessage.flowGeneratorSessionId, parsedFlagged);
  }, []);

  useSignalROn(SigROn.AiTutorResponseupdate, aiTutorCallback);
};
